import React, { useMemo, useState } from 'react';
import Context from './Context';
import safelyStringifyJSON from '../../../utils/safelyStringifyJSON';
import { useConfiguration } from './utils';
const ConfigurationProvider = ({ children, appNameConfig }) => {
    const config = useConfiguration(appNameConfig === null || appNameConfig === void 0 ? void 0 : appNameConfig.variant);
    const [is360Mode, setIs360Mode] = useState(config.immediatelyLoadImages);
    const activate360Mode = () => setIs360Mode(true);
    const deactivate360Mode = () => setIs360Mode(false);
    const contextValue = useMemo(() => ({
        ...appNameConfig,
        ...config,
        is360Mode,
        activate360Mode,
        deactivate360Mode,
    }), [safelyStringifyJSON(config), safelyStringifyJSON(appNameConfig), is360Mode]);
    return React.createElement(Context.Provider, { value: contextValue }, children);
};
export default ConfigurationProvider;
